import type { SubscribeToAiSettingsEvents } from 'lib-knowledge-management';

import { pubSub } from 'utils/pubSub';

/**
 * Relays the web socket's AI settings events, which the websocket saga
 * publishes on `pubSub`, to the knowledge management lib — which cannot reach
 * either.
 */
export const subscribeToAiSettingsEvents: SubscribeToAiSettingsEvents = ({
  onDraftUpdated,
  onVersionCreated,
  onVersionUpdated,
  onReconnected,
}) => {
  const disposers = [
    pubSub.subscribe('ai_settings:draft_updated', () => onDraftUpdated()),
    pubSub.subscribe('ai_settings:version_created', ({ version_id }) =>
      onVersionCreated(version_id),
    ),
    pubSub.subscribe('ai_settings:version_updated', ({ version_id }) =>
      onVersionUpdated(version_id),
    ),
    pubSub.subscribe('webSocketReconnected', onReconnected),
  ];

  return () => disposers.forEach((dispose) => dispose());
};
